import React from "react";
import { useUiDispatch, mainUiActions } from "../../../reducers/mainui.reducer";
import AtDialog from "../../molecules/AtDialog";
import { H5, Button } from "@blueprintjs/core";
import AtButton from "../../atoms/AtButton";
import AtIcon from "../../atoms/AtIcon";
import strings from "../../../strings";
const ConfirmationDialog = props => {
  const {
    isOpen,
    dialogTitle = strings.tools.saveAndReplaceOnserver,
    question = "Are you sure?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    handleConfirm,
    handleCancel
  } = props;

  const dispatchUiState = useUiDispatch();

  const handleCloseDialog = () => {
    dispatchUiState({ type: mainUiActions.SET_CONFIRMATION_DIALOG, payload: false });
  };
  const handleSecondaryClick = () => {
    handleCloseDialog();
    if (handleCancel) handleCancel();
  };
  const handlePrimaryClick = () => {
    if (handleConfirm) handleConfirm();
    handleCloseDialog();
  };
  return (
    <AtDialog
      onClose={handleCloseDialog}
      isOpen={isOpen}
      className="at-confirmation-dialog"
      size="xs"
    >
      <div className="at-dialog-area at-confirmation-dialog-area">
        <Button
          className="at-close-dialog-button"
          onClick={handleCloseDialog}
          minimal
          icon={<AtIcon icon="close"></AtIcon>}
        />
        <H5 className="at-dialog-heading">{dialogTitle}</H5>
        <div className="at-dialog-content">
          <div className="at-dialog-content-text"> {question}</div>
          <div className="at-confirmation-btns-area">
            <AtButton intent="primary" onClick={handlePrimaryClick} text={confirmText} />
            <AtButton intent="danger" onClick={handleSecondaryClick} text={cancelText} />
          </div>
        </div>
      </div>
    </AtDialog>
  );
};

export default ConfirmationDialog;
